/* VALKA · inicio: "Al carrito" en tarjetas y formulario de rastreo por WhatsApp. Sin dependencias. */
(function () {
  if (window.__vxlHome) return;
  window.__vxlHome = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastEl;
  var toastTimer;

  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vxl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('vxl-toast--error', !!isError);
    toastEl.innerHTML = html;
    // Forzar reflujo para reiniciar la transición.
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 4200);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('vxl:cart', { detail: { count: cart.item_count } }));
        return cart;
      });
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-vxl-add');
    if (!id || btn.classList.contains('is-loading')) return;
    var label = btn.querySelector('[data-vxl-label]');
    var original = label ? label.textContent : '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = btn.getAttribute('data-vxl-added') || original;
        toast(
          esc(btn.getAttribute('data-vxl-msg') || 'Producto agregado al carrito') +
            ' <a href="' + root + 'cart">' + esc(btn.getAttribute('data-vxl-cart') || 'Ver carrito') + '</a>'
        );
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 2600);
        return refreshCount();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'No pudimos agregar el producto. Inténtalo de nuevo.';
        toast(esc(msg), true);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  function onTrack(form, e) {
    e.preventDefault();
    var input = form.querySelector('input');
    var note = form.parentNode.querySelector('[data-vxl-track-note]');
    var value = (input.value || '').trim();
    if (!value) {
      if (note) note.textContent = form.getAttribute('data-empty') || 'Escribe tu número de guía o celular.';
      input.focus();
      return;
    }
    var phone = form.getAttribute('data-phone') || '';
    var text = (form.getAttribute('data-message') || '').replace('[dato]', value);
    if (text.indexOf(value) === -1) text = (text ? text + ' ' : '') + value;
    var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
    if (note) note.textContent = form.getAttribute('data-done') || '';
    var win = window.open(url, '_blank');
    if (win) win.opener = null;
    else window.location.href = url;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vxl-add]');
    if (btn) {
      e.preventDefault();
      addToCart(btn);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-vxl-track]');
    if (form) onTrack(form, e);
  });
})();
